<template>
  <div id="app" :class="theme">
    <span id="topTag"></span>
    <Header />
    <router-view />
    <Footer />
    <div class="el-backtop" :class="show" @click="backtop" style="right: 40px; bottom: 40px;">
      <i class="el-icon-caret-top"></i>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      theme: "",
      show: "",
    };
  },
  // watch: {
  //   $route: ["toggleNav"],
  // },
  methods: {
    // getPath() {
    //   this.$store.commit("changePage", this.$route.path);
    // },

    backtop() {
      document.querySelector("#topTag").scrollIntoView({ block: "end", behavior: "smooth" });
    },
  },
  created() {
    this.theme = this.$store.state.subject;
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));
    }

    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    window.addEventListener(
      "scroll",
      (e) => {
        let top = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
        if (top > 85) {
          this.show = "show";
        } else {
          this.show = "";
        }
      },
      false
    );
  },
  components: {
    Header,
    Footer,
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 80px;
  .el-backtop {
    display: none;
    transition: display 1s ease 0s;
    text-align: center;
    line-height: 2;
    &.show {
      display: inline-block;
    }
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.fullscreen .el-dialog {
  width: 100% !important;
  height: 90vh !important;
  margin: 0 !important;
  &__body {
    padding: 0 !important;
  }
  &__header {
    padding: 10px 10px 10px;
    color: #eee;
    background-color: #333;
  }
}
</style>
